/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Audio_Embed_Export_Source_Option_OriginalInputs */



/**
* | output |
* | --- |
* | "Original • {label}" |
*
* @param {Audio_Embed_Export_Source_Option_OriginalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_source_option_original = /** @type {((inputs: Audio_Embed_Export_Source_Option_OriginalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Source_Option_OriginalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Originale • ${i?.label}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Оригинал • ${i?.label}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`原文 • ${i?.label}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オリジナル • ${i?.label}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मूल • ${i?.label}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
	return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
});